import { Box, Chip, Dialog, DialogContent, IconButton, Popover, Typography } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useCallback, useRef, useState } from 'react';
import { useChipMenuStyles } from './styles';
import { useUpBreakpoint } from '@uplift/hooks';

export type ChipMenuProps = {
  title: React.ReactNode;
  contentTitle: React.ReactNode;
  onClose?: () => void;
  cancelButtonText?: React.ReactNode;
  onCancel?: () => void;
  applyButtonText?: React.ReactNode;
  onApply?: () => void;
};

export const ChipMenu: React.FC<ChipMenuProps> = ({ contentTitle, title, onClose, children }) => {
  const { classes } = useChipMenuStyles();
  const [ open, setOpen ] = useState(false);
  const anchor = useRef<HTMLDivElement>(null);
  const isSmUp = useUpBreakpoint('sm');

  const handleOpen = useCallback(() => {
    setOpen(x => !x);

    if (!open && onClose) {
      onClose();
    }
  }, [ onClose, open ]);

  return (
    <>
      <Chip variant="outlined" color="primary" label={title} onClick={handleOpen} ref={anchor} />
      {isSmUp ? (
        <Popover
          open={open}
          anchorEl={anchor?.current}
          onClose={handleOpen}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
        >
          <Box className={classes.content} onClick={handleOpen}>
            <Box mb={1}>
              <Typography variant="body1">
                {contentTitle}
              </Typography>
            </Box>
            {children}
          </Box>
        </Popover>
      ) : (
        <Dialog fullScreen open={open}>
          <Box className={classes.title}>
            <Typography variant="h3">
              {contentTitle}
            </Typography>
            <IconButton aria-label="close" onClick={handleOpen} size="small">
              <CloseOutlined />
            </IconButton>
          </Box>
          <DialogContent className={classes.content} onClick={handleOpen}>
            {children}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
